import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { DownOutlined } from '@ant-design/icons';
//FIXME Button currently has an outstanding issue https://github.com/ant-design/ant-design/issues/22493 which throws "findDOMNode was passed an instance of Wave which is inside StrictMode"
import { Menu, Dropdown, Button } from 'antd';
// import { ActionCreatorType } from 'src/store';
import styles from './GlobalFilter.module.scss';

export interface GlobalFilterItem {
  id: string;
  [name_lang: string]: string;
}

interface GlobalFilterProps {
  dispatch: any;
  filterName: string;
  // actionCreator: ActionCreatorType;
  actionCreator: any;
  items: GlobalFilterItem[];
}

const GlobalFilter = ({ dispatch, actionCreator, items = [], filterName }: GlobalFilterProps) => {
  const { locale } = useIntl();

  const initialState = items.map(() => false);
  // State to keep the selected filters
  const [activeFilters, setActiveFilters] = useState(initialState);
  //State to check if the selected filters have changed since the last time the action was dispatched
  const [sentFilters, setSentFilters] = useState(initialState);
  // State to keep/set the visibility of the dropdown menu, so it can be closed upon clicking on buttons
  const [menuVisibility, setMenuVisibility] = useState(false);

  const _handleVisibleChange = (flag) => {
    setMenuVisibility(flag);
    // If user clicks outside the Menu, save selected filters
    !flag && save();
  };

  const _onClickMenuItem = (idx) => {
    const newState = [...activeFilters];
    newState[idx] = !newState[idx];
    setActiveFilters(newState);
  };

  const _onClickSave = () => {
    setMenuVisibility(false);
    save();
  };

  const _onClickReset = () => {
    setActiveFilters(initialState);
    setMenuVisibility(false);
    save(true);
  };

  const hasFilterChanged = () => {
    return activeFilters.some((filter, idx) => sentFilters[idx] !== filter);
    // Initial state when no action has been dispatched. Check if one of the filters is active and Save if it is
    // (sentFilters.length === 0 && activeFilters.some((filter) => filter)) ||
    // //Check if the current state is different from the one sent on last Save
    // sentFilters.some((filter, idx) => activeFilters[idx] !== filter)
  };

  const save = (reset = false) => {
    if (!hasFilterChanged() && !reset) return;
    // By default, reset filters
    let filteredKeys = [];
    let newSentFilters = initialState;
    if (!reset) {
      // Get items to filter on
      filteredKeys = items.filter((_item, idx) => !!activeFilters[idx]);
      // Update the sentFilters state to be sent
      newSentFilters = activeFilters;
    }
    //Set sentFilters state
    setSentFilters(newSentFilters);
    // Dispatch the relevant action passed in the props
    dispatch(actionCreator(filteredKeys));
  };
  const menu = items && (
    <Menu>
      {items.map((item, idx) => (
        <Menu.Item key={idx}>
          <a
            className={activeFilters[idx] ? styles.active : ''}
            onClick={_onClickMenuItem.bind(null, idx)}>
            {item.name || item['name_' + locale]}
          </a>
        </Menu.Item>
      ))}
      <Menu.Divider />
      <Menu.Item key={items.length}>
        {activeFilters.some((filter) => filter) && (
          <Button type="link" onClick={_onClickReset}>
            reset
          </Button>
        )}
        <Button type="primary" onClick={_onClickSave} disabled={!hasFilterChanged()}>
          save
        </Button>
      </Menu.Item>
    </Menu>
  );
  return (
    <div className={styles.container}>
      <Dropdown
        overlay={menu}
        visible={menuVisibility}
        onVisibleChange={_handleVisibleChange}
        trigger={['click']}>
        <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
          {filterName}
          <DownOutlined />
        </a>
      </Dropdown>
    </div>
  );
};

export default connect()(GlobalFilter);
